export default __webpack_public_path__ + "static/banner2-b3a78a2b95ce8b1de4fa79104e3fecbc.png";